const styles = theme => ({
  root: {
    display: 'flex',
    flexDirection: 'column',
    width: '100%',
    height: '100%',
    gap: 16,
    paddingBottom: 16,
  },
  teamListRoot: {
    height: 'calc(80vh - 40px)',
    width: '100%',
    //backgroundColor: '#F4F6F8',
    padding: '24px',
    borderRadius: '16px',
    marginBottom: 16,
    minHeight: '420px',
    boxShadow:
      '0px 0px 2px 0px rgba(145, 158, 171, 0.12), 0px 12px 24px -4px rgba(145, 158, 171, 0.12)',
  },
  teamLearnerAccessImage: {
    width: '64px',
    height: '64px',
  },
  learnerAccessType: {
    fontSize: '16px',
    fontWeight: 500,
    color: '#015ffb',
  },
  learnerAccessDescription: {
    maxWidth: '338px',
    textAlign: 'center',
  },
  learnerAccessContainer: {
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'center',
    alignItems: 'center',
    height: '100%',
    width: '100%',
    gap: 16,
  },
})

export default styles
